import { AppSettingService } from './../../services/app-setting.service';
import { Component, OnInit } from '@angular/core';
import { HttpclientService } from '../../services/httpclient.service';
import { Router } from '@angular/router';
import { Menubardto } from '../../model/menubardto';
import { AuthenticationService } from 'src/app/services/authentication.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  //username = 'ravi.s.k@contractors.axaltacs.com';
  //password = 'wrjrgXbNOirqE5FRpKBkxg==';
  //username=""
  invalidLogin = false;
  isSession : boolean=false;

  collapsed: boolean;
  menubar: Menubardto[];
  menuBarLength: number;
  isMenu;
  isDistributor:boolean;  
  

  constructor(public service: HttpclientService, private router: Router, private authService: AuthenticationService,
              public appSettingService: AppSettingService) {
    service.username = sessionStorage.getItem('username');
    this.collapsed = false;
    this.appSettingService.globelDateFormat = sessionStorage.getItem('globalDateFormat');
    this.isDistributor = sessionStorage.getItem('roleId')!='6' ? true : false;        
  }

  toggleCollapsed() {
  //  alert('sdsd');
    this.collapsed = !this.collapsed;

  }


  ngOnInit() {
    this.collapsed = false;
    this.service.username = sessionStorage.getItem('username');
    if(this.service.username!=null && this.service.username!="" && this.service.username!=undefined){
      this.isSession = true ;
    }

    this.getMenubar();        
  }

  logout() {
    console.log("sessionStorage.getItem('username')..."+sessionStorage.getItem('username'));
    this.authService.logOut1(sessionStorage.getItem('username'), sessionStorage.getItem('password')).subscribe(
      data => {
        this.appSettingService.clearGlobelVariable();
        console.log(data+"before");
        this.router.navigate(['']);
        this.invalidLogin = true;
      },
      error => {
        console.log('error'+error);
        this.invalidLogin = false;

      }
    )
  }

// getMenubar(){
//   this.service.getMenubar().subscribe(
//     data => {
//  this.menubar = data;

//  console.log('..menu...'+data.length);
//     }
//   )

// }


isOk(){
  this.isMenu = false;
  this.logout();
}

getMenubar() {
  
  if (Array.isArray(this.appSettingService.menubarGlobelList) && this.appSettingService.menubarGlobelList.length) {
    // array exists and is not empty
    this.menubar = this.appSettingService.menubarGlobelList;
   // console.log('Menubar is not null from frontend : ' + this.appSettingService.menubarGlobelList);
    } else {
      
      this.service.getMenubar().subscribe(
        data => {          
          this.menubar = data;
          this.appSettingService.menubarGlobelList = data;

          console.log('this.menubar.length => '+this.menubar.length);
          this.menuBarLength = this.menubar.length;
          if( this.menubar.length === 0){
            this.isMenu = true;
          }

          
          
        }
      );
      //console.log('Menubar is null from backend : ' + this.appSettingService.menubarGlobelList);
    }
    
}

}
